import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import { routes } from '../../assets/constants';
import { CreateQuoteRequestPayload, QuoteRequest, VendorInvoice } from '../models/billing.model';

/**
 * Vendor-facing Enterprise quote requests. Submitting does NOT change the
 * vendor's plan — it records their needs and notifies the sales team.
 */
export const useQuoteApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);

  const createQuoteRequest = (payload: CreateQuoteRequestPayload): Promise<QuoteRequest> =>
    sendAuthGuardedRequest(ApiMethod.POST, routes.billing.quoteRequest, payload) as Promise<QuoteRequest>;

  // The vendor's own quote requests (to surface an accepted, payable one).
  const getMyQuoteRequests = (): Promise<QuoteRequest[]> =>
    sendAuthGuardedRequest(ApiMethod.GET, routes.billing.myQuoteRequests) as Promise<QuoteRequest[]>;

  // Issue a wire invoice for an accepted wire-preference quote (at the quoted amount).
  const createQuoteWireInvoice = (quoteId: string): Promise<VendorInvoice> =>
    sendAuthGuardedRequest(ApiMethod.POST, routes.billing.quoteWireInvoice, { quoteId }) as Promise<VendorInvoice>;

  return { createQuoteRequest, getMyQuoteRequests, createQuoteWireInvoice };
};
